"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _uiKit = require("@devsta/ui-kit");

var _commonReact = require("@devsta/common-react");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function TabDrawer() {
  return _react.default.createElement(_uiKit.Drawer, {
    isVertical: true,
    tabIcons: ['comments']
  }, _react.default.createElement(_commonReact.CommentsTab, {
    tabTitle: "All Comments",
    showAddCommentButton: true
  }));
}

var _default = TabDrawer;
exports.default = _default;